import React from 'react'
import Spacer from './spacer'
import Article from './article'

export default function NewsFeed({ news }) {
    return (
        <div>
            <div className='grid-2-1 p10 gap-10 m-flex m-flex-col'>
                <div className='h-100'>

                    <div id='news-wrapper' className='h-100 '>
                        <div className='h-100vh-50  flex flex-col w-100 ' data-scroll-sticky data-scroll data-scroll-target='#news-wrapper' >
                            <Spacer />
                            <Article innerClassName='border-box' className='border-box flex-grow-1  w-100 ' article={news.nodes[0]} />
                        </div>
                        <div className='m-hide' />

                    </div>
                </div>

                <div className=''>
                    <div className='h-100vh-50 m-hide' />
                    <div className=' grid grid-rows-3 gap-10 justify-start border-box  border-box pt100 '>
                        {news.nodes.slice(1, 4).map((article, index) => {
                            return <Article spacer={false} textClassName='text-small' className=' justify-between flex-grow-1' key={index} article={article} />
                        })}

                    </div>
                </div>

            </div>
            <Spacer />
            <div className='grid gap-10 p10 '>
                {news.nodes.slice(4).map((article, index) => {
                    return <Article textClassName='text-small' className=' justify-between flex-grow-1' key={index} article={article} />
                })}
            </div>

        </div>
    )
}
